import { DAILY_TAB, LIVE_GAME_TAB, ModeIds } from "@chesshotel/constants";
import useTranslation from "next-translate/useTranslation";
import {
  doCreateGame,
  lobbyStore,
  setBlinking,
  setTab,
  showChallengePopup,
  useLobby,
} from "../../redux/lobby";
import ChooseGameDropdown from "./ChooseGameDropdown";
import { useUser } from "../../redux/user";
import { setBlinkingDaily, useDaily } from "../../redux/daily";
import { createInvite } from "../shared/challengeController";
import { convertToNumber } from "../../util/util";
import PlayersOnline from "./PlayersOnline";
import { useState } from "react";
import LeagueCardContainer from "./infoCards/LeagueCardContainer";
import PracticeCardContainer from "./infoCards/PracticeCardContainer";
import { useWebPush } from "@/redux/webPush";
import WebPushPopup from "../daily/WebPushPopup";
import { settingsStore } from "@/redux/settings";
import { LobbyWs } from "@/services/wsOutRoutes";
import { useWsConnection } from "@/redux/wsConnection";
import { siteDataStore } from "@/redux/siteData";
import { reportRussiaClientHealth } from "@/services/clientHealth";

function createQuickMatch() {
  const { minOpponentRating, maxOpponentRating, noGuests } =
    settingsStore.getState();

  const {
    time,
    inc,
    variant,
    modeId,
    leaguePlay,
    gamesCreated,
    filterGuestTime,
  } = lobbyStore.getState();

  const { chessPartyMode } = siteDataStore.getState();

  const game = {
    time,
    inc,
    minElo: minOpponentRating,
    maxElo: maxOpponentRating,
    variant,
    leaguePlay,
    modeId,
    noGuests,
    filterGuestTime,
    ...(chessPartyMode && { isChessParty: true }),
  };

  LobbyWs.createQuickMatch(game);
  reportRussiaClientHealth("quick_match_created", {
    time,
    inc,
    variant,
    leaguePlay,
    modeId,
    noGuests,
    filterGuestTime,
    isChessParty: Boolean(chessPartyMode),
  });

  let gameCreated = false;
  gamesCreated.forEach((game) => {
    if (time === game.time && inc === game.inc && variant === game.variant) {
      gameCreated = true;
    }
  });
  if (!gameCreated) {
    doCreateGame({ time, inc, variant });
  }
}

export default function CreateGame({ isDesktop }) {
  const { t } = useTranslation("common");
  const { t: lobbyT } = useTranslation("lobby");
  const { leaguePlay, time, inc, variant, turnLength, gamesCreated } =
    useLobby();
  const { invites } = useDaily();
  const { id, memberLoggedIn } = useUser();
  const { modeId } = useLobby();
  const [show, setShow] = useState(false);

  const [showWepPushPopup, setShowWepPushPopup] = useState(false);
  const { isSubscribed } = useWebPush();
  const { wsConnected } = useWsConnection();

  function checkIfUserDailyGameExists(challs) {
    if (!challs) return false;

    for (let i = 0; i < challs.length; i++) {
      const chall = challs[i];
      if (
        chall.userId === id &&
        chall.turnLength === convertToNumber(turnLength) &&
        chall.variantId === convertToNumber(variant)
      ) {
        return true;
      }
    }
    return false;
  }

  function checkIfLiveGameExists(challs) {
    if (!challs) return false;

    for (let i = 0; i < challs.length; i++) {
      const chall = challs[i];
      if (
        convertToNumber(chall.time) === convertToNumber(time) &&
        convertToNumber(chall.inc) === convertToNumber(inc) &&
        convertToNumber(chall.variant) === convertToNumber(variant)
      ) {
        return true;
      }
    }
    return false;
  }

  function handlePlay() {
    if (isDesktop) {
      setTab(modeId === ModeIds.DAILY ? DAILY_TAB : LIVE_GAME_TAB);
    }

    if (modeId === ModeIds.DAILY) {
      if (!memberLoggedIn) {
        return;
      }
      const gameAlreadyRequested = checkIfUserDailyGameExists(invites);
      if (gameAlreadyRequested) {
        setBlinkingDaily({ userId: id, turnLength, variant, blinking: true });
      } else {
        if (!isSubscribed) {
          setTimeout(() => {
            setShowWepPushPopup(true);
          }, 500);
        }
        createInvite(
          {
            modeOption: variant,
            timeOption: turnLength,
            leaguePlay,
          },
          invites
        );
      }
    } else {
      const gameAlreadyRequested = checkIfLiveGameExists(gamesCreated);
      if (gameAlreadyRequested) {
        setBlinking({ time, inc, variant, blinking: true });
      } else {
        createQuickMatch();
      }
    }
  }

  return (
    <>
      {showWepPushPopup && <WebPushPopup show={setShowWepPushPopup} />}
      <div
        className={`flex flex-col justify-between w-full h-auto bg-white rounded-b-md md:p-0 md:pt-0 md:rounded-t-xl md:border md:border-b-[3px] md:min-h-[488px]`}
      >
        <div className="flex flex-col w-full">
          {leaguePlay ? <LeagueCardContainer isDesktop={isDesktop} /> : <PracticeCardContainer />}

          <div className="flex flex-col p-3 md:p-4">
            <div className="flex flex-col">
              <ChooseGameDropdown setShow={setShow} show={show} />
              {
                <button
                  className={`mt-3 w-full h-11 btn btn-base btn-red disabled:opacity-50`}
                  disabled={
                    (modeId == ModeIds.DAILY && !memberLoggedIn) || !wsConnected
                  }
                  onClick={handlePlay}
                >
                  {t("Play")}
                </button>
              }
              {!show && (
                <button
                  className="mt-3 w-full h-11 text-white btn btn-base bg-altgray-700 enabled:hover:bg-altgray-600 disabled:opacity-50"
                  disabled={
                    (modeId == ModeIds.DAILY && !memberLoggedIn) || !wsConnected
                  }
                  onClick={() => showChallengePopup(true)}
                >
                  {lobbyT("Play with a friend")}
                </button>
              )}
            </div>
          </div>
        </div>
        {(!show || !memberLoggedIn) && isDesktop && (
          <div className="flex pb-4">{<PlayersOnline />}</div>
        )}
      </div>
    </>
  );
}
